// src/hooks/useExportRegistry.ts
// Fetches the dynamic exportable tables registry from the backend.

import { useCallback, useEffect, useState } from "react";
import { fetchData } from "api/apiHelpers";
import logger from "utils/logger";

export interface UniversalTableInfo {
  key: string;
  label: string;
  cardinality: "one_per_patient";
}

export interface DomainTableInfo {
  domain_key: string;
  label: string;
  tables: ("statictable" | "eventtable")[];
}

export interface ExportRegistry {
  universal_tables: UniversalTableInfo[];
  domain_tables: DomainTableInfo[];
}

const useExportRegistry = () => {
  const [registry, setRegistry] = useState<ExportRegistry | null>(null);
  const [loading, setLoading] = useState(true);

  const fetch_ = useCallback(async () => {
    try {
      const data = await fetchData<ExportRegistry>("/insights/exportable-tables/");
      setRegistry(data);
    } catch (err) {
      logger.error("Failed to fetch export registry:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch_();
  }, [fetch_]);

  return { registry, loading };
};

export default useExportRegistry;
